import Cust1 from "../assets/1-navantis-logo.jpg"
import Cust2 from "../assets/2-cibc-logo.jpg"
import Cust3 from "../assets/3-bmo-logo.jpg"
import Cust4 from "../assets/4-scotia-logo.jpg"
import Cust5 from "../assets/5-telus-logo.jpg"
import Cust6 from "../assets/6-qualicom-logo.jpg"
import Cust7 from "../assets/7-unisystech-logo.jpg"
import Cust8 from "../assets/8-wake-media-logo.jpg"

const CustomerCardData = [
    {
        imgsrc: Cust1,
     },
    {
        imgsrc: Cust2,
    },
    {
        imgsrc: Cust3,

    },
    {
        imgsrc: Cust4,
     },
    {
        imgsrc: Cust5,
    },
    {
        imgsrc: Cust6,

    },
    {
        imgsrc: Cust7,
     },
    {
        imgsrc: Cust8,

    }
];

export default CustomerCardData;